export default {
      id: "ic-han-physical-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-han-physical-usage",
      toString: function () {
        return this.url;
      }
    }